var _path, _path2, _path3, _path4, _circle, _circle2, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 130 130",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m36.011 32.315-1.877 1.8105-1.8086 1.875 5.3594 9.4297 3.75-0.10742 17.529 17.756 4.0977-4.1504-17.729-17.504 0.10743-3.75zm36.631 32.748-7.4902 7.6562 21.51 23.404s4.5471 4.3075 9.1387-0.33398c4.5916-4.6415 0.33399-9.1387 0.33399-9.1387z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m79.6 66.2-13.2 13.4",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m87.563 32.804c-0.77371-0.02374-1.7826 0.04985-2.334 0.04883-6.3158 4.1e-4 -11.435 5.1936-11.436 11.6 8e-6 1.0971 0.1608 2.1542 0.44141 3.1602l-26.414 26.752c-0.98766-0.27726-2.0265-0.43259-3.1016-0.42773-6.3165 0.0283-11.414 5.2456-11.385 11.652 0.0095 1.1579 0.18987 2.3083 0.53516 3.4121l5.2226-5.2695 3.8984-0.13477 3.7969 3.7637 0.25391 3.7793-5.4746 5.5254c-0.38854 0.39212 0.15197 0.51106 0.92578 0.53125 0.77381 0.02019 1.7807-0.05904 2.332-0.06055 6.3157-0.02939 11.412-5.2445 11.383-11.65-5e-3 -1.097-0.16986-2.1536-0.45508-3.1582l26.186-26.768c1.0423 0.31726 2.1469 0.49211 3.291 0.49219 6.3165 6.83e-4 11.437-5.1928 11.438-11.6-0.0042-1.1579-0.17932-2.3087-0.51953-3.4141l-5.2461 5.2461-3.8984 0.11719-3.7812-3.7812-0.23633-3.7812 5.5-5.5c0.39033-0.39033-0.14817-0.51141-0.92188-0.53516z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8434
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m55.663 74.552 18.503-18.892",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.819,
    cy: 52.814,
    r: 1,
    fill: "currentColor",
    fillOpacity: 0.9946,
    strokeWidth: 0
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.204,
    cy: 76.881,
    r: 1,
    fill: "currentColor",
    fillOpacity: 0.9946,
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m78.2 78.4 12 11.6",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.c31a1916753362eca32e6bbed43f6ad3.svg";
export { ForwardRef as ReactComponent };